<template>
  <div>
    <div class="fotter">
      <!--<div class="foot_content ">-->
        <!--<div class="foot_line">全国信鸽公棚通讯录</div>-->
        <!--<div :class="{lind:true,   open_dia:show,shouqi:!show} ">-->

          <!--<div class="child"> 北京赛客国际公棚</div>-->
          <!--<div class="child"> 北京石景山赛鸽公棚</div>-->
          <!--<div class="child"> 北京房山赛鸽公棚（原皓月房山棚）</div>-->
          <!--<div class="child"> 北京远方蓝通赛鸽公棚</div>-->
          <!--<div class="child"> 惠翔竞翔投资管理有限公司</div>-->
          <!--<div class="child"> 北京bgy百鸽园文化交流有限公司</div>-->
          <!--<div class="child"> 北京欣福亮赛鸽公棚 （春棚）</div>-->
          <!--<div class="child"> 北京震展飞江赛鸽公棚</div>-->
          <!--<div class="child"> 北京路喜德赛鸽公棚</div>-->
          <!--<div class="child"> 北京京运赛鸽养殖中心</div>-->
          <!--<div class="child"> 北京艺嘉凯旋赛鸽公棚</div>-->
          <!--<div class="child"> 北京云天赛鸽公棚</div>-->
          <!--<div class="child"> 北京顺昌赛鸽公棚</div>-->
          <!--<div class="child"> 京东燕翔国际赛鸽中心</div>-->
          <!--<div class="child"> 京东燕郊·春辉赛鸽公棚</div>-->
          <!--<div class="child"> 北京新方圆赛鸽公棚</div>-->
          <!--<div class="child"> 京东长明赛鸽中心</div>-->
          <!--<div class="child"> 北京国信达赛鸽公棚</div>-->
          <!--<div class="child"> 北京玉翅通达公棚</div>-->
          <!--<div class="child"> 北京翔瑞缘公棚</div>-->
          <!--<div class="child"> 北京合利兴赛鸽公棚</div>-->
          <!--<div class="child"> 天津皓翔赛鸽公棚</div>-->
          <!--<div class="child"> 天津市天野赛鸽公棚</div>-->
          <!--<div class="child"> 天津竞翔信鸽养殖有限公司</div>-->
          <!--<div class="child"> 天水九大联盟赛鸽俱乐部</div>-->
          <!--<div class="child"> 天津市泽众鑫赛鸽公棚</div>-->
          <!--<div class="child"> 天津市津福赛鸽公棚</div>-->
          <!--<div class="child"> 天津泓成通信鸽养殖有限公司</div>-->
          <!--<div class="child"> 天津市天立国际赛鸽公棚</div>-->
          <!--<div class="child"> 天津通翔赛鸽公棚</div>-->
          <!--<div class="child"> 天津宇航赛鸽俱乐部</div>-->
          <!--<div class="child"> 天津源博赛鸽公棚</div>-->
          <!--<div class="child"> 天津锦堂赛鸽运动俱乐部</div>-->
          <!--<div class="child"> 天津卓翔赛鸽公棚</div>-->
          <!--<div class="child"> 天津天立赛鸽公棚（小棚）</div>-->
          <!--<div class="child"> 天津通力赛鸽公棚</div>-->
          <!--<div class="child"> 天津市鹏翔赛鸽公棚</div>-->
          <!--<div class="child"> 天津元旭赛鸽公棚</div>-->
          <!--<div class="child"> 天津德行天下赛鸽公棚</div>-->
          <!--<div class="child"> 天津万胜赛鸽公棚</div>-->
          <!--<div class="child"> 天津宇航赛鸽公棚</div>-->
          <!--<div class="child"> 天津市丽翔国际赛鸽公棚</div>-->
          <!--<div class="child"> 天津江盛源信鸽俱乐部</div>-->
          <!--<div class="child"> 天津夺冠赛鸽公棚</div>-->
          <!--<div class="child"> 天津信泽慧海公棚</div>-->
          <!--<div class="child"> 天津兆丰赛鸽公棚</div>-->
          <!--<div class="child"> 天津清华庄园赛鸽公棚</div>-->
          <!--<div class="child"> 天津彪行天下赛鸽公棚</div>-->
          <!--<div class="child"> 华顺德赛鸽公棚春棚</div>-->
          <!--<div class="child"> 江苏翔盛赛鸽中心</div>-->
          <!--<div class="child"> 江苏金翼赛鸽公棚</div>-->
          <!--<div class="child"> 江苏徐州万羽赛鸽公棚</div>-->
          <!--<div class="child"> 江苏长江国际信鸽公棚</div>-->
          <!--<div class="child"> 江苏翔圣赛鸽中心</div>-->
          <!--<div class="child"> 江苏淮安四方赛鸽俱乐部</div>-->
          <!--<div class="child"> 江苏博晖国际赛鸽俱乐部</div>-->
          <!--<div class="child"> 江苏德缘赛鸽中心</div>-->
          <!--<div class="child"> 江苏云外水庄赛鸽中心（春棚）</div>-->
          <!--<div class="child"> 江苏云外水庄国际赛鸽俱乐部</div>-->
          <!--<div class="child"> 江苏淮安火车头公棚</div>-->
          <!--<div class="child"> 江苏金马国际赛鸽俱乐部</div>-->
          <!--<div class="child"> 扬州福联翱翔赛鸽中心</div>-->
          <!--<div class="child"> 海南北大荒江苏赛鸽中心</div>-->
          <!--<div class="child"> 江苏五星国际赛鸽文化交流中心</div>-->
          <!--<div class="child"> 常州龙翔赛鸽中心</div>-->
          <!--<div class="child"> 河北开尔赛鸽寄养棚</div>-->
          <!--<div class="child"> 河北春翔国际赛鸽公棚春棚</div>-->
          <!--<div class="child"> 任丘市爱翔国际赛鸽公棚</div>-->
          <!--<div class="child"> 河北张家口盛世达国际赛鸽公棚</div>-->
          <!--<div class="child"> 邯郸市温暖信鸽俱乐部</div>-->
          <!--<div class="child"> 唐山阳光赛鸽寄养棚</div>-->
          <!--<div class="child"> 河北正定百鸽联盟赛鸽寄养中心</div>-->
          <!--<div class="child"> 河北唐山腾飞公棚</div>-->
          <!--<div class="child"> 唐山鑫��赛鸽公棚</div>-->
          <!--<div class="child"> 唐山市春朝国际赛鸽公棚春棚</div>-->
          <!--<div class="child"> 唐山市春朝国际赛鸽公棚小春棚</div>-->
          <!--<div class="child"> 秦皇岛凯鸽赛鸽公棚</div>-->
          <!--<div class="child"> 河北怀来源翔克劳沃公棚</div>-->
          <!--<div class="child"> 廊坊市伍龙国际赛鸽公棚</div>-->
          <!--<div class="child"> 河北龙港赛鸽养殖中心</div>-->
          <!--<div class="child"> 河北高碑店顺鸿赛鸽公棚</div>-->
          <!--<div class="child"> 唐山天翼胜翔赛鸽公棚</div>-->
          <!--<div class="child"> 秦皇岛盛邦友翔赛鸽公棚</div>-->
          <!--<div class="child"> 河北翔远赛鸽公棚</div>-->
          <!--<div class="child"> 河北明会赛鸽公棚</div>-->
          <!--<div class="child"> 唐山领航国际赛鸽公棚</div>-->
          <!--<div class="child"> 秦皇岛市三毛信鸽公棚</div>-->
          <!--<div class="child"> 张家口晓辉爱心赛鸽公棚</div>-->
          <!--<div class="child"> 石家庄同翔赛鸽公棚</div>-->
          <!--<div class="child"> 秦皇岛��海�w川赛鸽公棚</div>-->
          <!--<div class="child"> 开尔国际赛鸽爱心公棚</div>-->
          <!--<div class="child"> 秦皇岛梦想阳光国际赛鸽公棚</div>-->
          <!--<div class="child"> 秦皇岛市玉龙赛鸽爱心公棚</div>-->
          <!--<div class="child"> 河南爱心和平鸽寄养小公棚</div>-->
          <!--<div class="child"> 河南省平顶山市亦成赛鸽中心</div>-->
          <!--<div class="child"> 河南宇森赛鸽公棚</div>-->
          <!--<div class="child"> 焦作鸿鹄赛鸽有限责任公司</div>-->
          <!--<div class="child"> 河南中正赛鸽公棚</div>-->
          <!--<div class="child"> 郑州信义公棚信鸽养殖有限公司</div>-->
          <!--<div class="child"> 河南濮阳市祥和信鸽公棚</div>-->
          <!--<div class="child"> 开封市鑫运赛鸽寄养中心</div>-->
          <!--<div class="child"> 河南京朝信鸽公棚</div>-->
          <!--<div class="child"> 河南奥翔信鸽文化交流中心</div>-->
          <!--<div class="child"> 河南柘城香柏年赛鸽公棚</div>-->
          <!--<div class="child"> 河南省信鸽训练基地</div>-->
          <!--<div class="child"> 郑州铂霖公棚</div>-->
          <!--<div class="child">环球（郑州）国际赛鸽俱乐部</div>-->
          <!--<div class="child"> 开封五洲赛鸽公棚</div>-->
          <!--<div class="child"> 河南许昌灵武山庄赛鸽公棚</div>-->
          <!--<div class="child"> 四川省渔樵(集团)赛鸽公棚</div>-->
          <!--<div class="child"> 乐山大福赛鸽公棚</div>-->
          <!--<div class="child"> 鸽色天乡国际信鸽竞翔村</div>-->
          <!--<div class="child"> 四川天福赛鸽中心</div>-->
          <!--<div class="child"> 乐山犍为天元赛鸽公棚</div>-->
          <!--<div class="child"> 四川蜀翔职业赛鸽俱乐部</div>-->
          <!--<div class="child"> 四川省遂宁市红军赛鸽公棚</div>-->
          <!--<div class="child"> 成都嘉兴信鸽文化咨询服务有限公司</div>-->
          <!--<div class="child"> 成都国奥(国际)赛鸽中心</div>-->
          <!--<div class="child"> 四川福阳赛鸽公棚</div>-->
          <!--<div class="child"> 四川绵阳鹏翔赛鸽公棚</div>-->
          <!--<div class="child"> 四川大华赛鸽公棚</div>-->
          <!--<div class="child"> 四川蜀地翔圣赛鸽公棚</div>-->
          <!--<div class="child"> 四川省宜宾市长江一号国际公棚</div>-->
          <!--<div class="child"> 四川明鸿国际赛鸽城</div>-->
          <!--<div class="child"> 四川万利达赛鸽公棚</div>-->
          <!--<div class="child"> 甲子园信鸽国际贸易（成都）有限公司</div>-->
          <!--<div class="child"> 四川乐山蓝天傲翔赛鸽公棚</div>-->
          <!--<div class="child"> 四川俊翔赛鸽公棚</div>-->
          <!--<div class="child"> 内江市三多信鸽竞赛中心</div>-->
          <!--<div class="child"> 四川攀枝花市太阳城赛鸽中心</div>-->

        <!--</div>-->
        <!--<div class="sho tab_1" @click="()=>{-->
            <!--this.show=!this.show-->
        <!--}" v-if="show">展开-->
        <!--</div>-->
        <!--<div class="sho tab_2" @click="()=>{-->
            <!--this.show=!this.show-->
        <!--}" v-if="!show">收起-->
        <!--</div>-->

        <!--&lt;!&ndash;<div>國際信鴿產業集團有限公司授权</div>&ndash;&gt;-->

        <!--&lt;!&ndash;<div>&ndash;&gt;-->
          <!--&lt;!&ndash;<div><p>Copyright © 2013-2020 赛格锐·云直播网站版权所有 </p></div>&ndash;&gt;-->
          <!--&lt;!&ndash;<div><a href="http://www.beian.miit.gov.cn/ " style="color: white;text-decoration: none">津ICP备19003468号-3</a>&ndash;&gt;-->
          <!--&lt;!&ndash;</div>&ndash;&gt;-->
        <!--&lt;!&ndash;</div>&ndash;&gt;-->
      <!--</div>-->
      <div class="footio">
        <p>國際信鴿產業集團有限公司授權</p>
        <p>
          <span class="footer_copy">Copyright © {{currentYear}} <a href="https://www.sagerantech.com/">赛格锐版权所有</a></span> - <span class="footer_credit"><a href="http://beian.miit.gov.cn/">津ICP备19003468号-7</a></span>
        </p>
        <div style="width:600px;margin:0 auto; padding:5px 0;">
          <p><a target="_blank" href="https://www.12377.cn/">中国互联网举报中心</a >   举报邮箱：common@chxinge.com</p >
        </div>  
          
        <div style="width:600px;margin:0 auto; padding:0px 0;">

        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=12011602000756" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
          <img style="width: 16px;height: 16px;margin-top: 2px;float:left;" src="https://xgzh3.oss-cn-hangzhou.aliyuncs.com/beian/beian_img.png" />
          <p style="float:right;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">津公网安备12011602000756号</p >
        </a >
        <span style="display: inline-block;margin-left: 10px;" id="cnzz_stat_icon_1279820165"><a href="https://www.cnzz.com/stat/website.php?web_id=1279820165" target="_blank" title="站长统计"><img border="0" hspace="0" vspace="0" src="https://icon.cnzz.com/img/pic.gif"></a></span>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      show: false,
      currentYear: new Date().getFullYear()
    }
  }
}
</script>
<style>
  .fotter {
    padding : 20px 0px;
    width: 100%;
    min-height: 96px;
    background: #292E31;
    box-sizing: border-box;

    color: #8F8F8F;
    line-height: 25px;
    margin: 0 auto;

  }

  .foot_content {
    margin: 0 auto;
    width: 1200px;
    color: #ffffff;
    padding-bottom: 50px;
    border-bottom: 1px solid #474747;
  }
.footio{
  text-align: center;
  padding-left: 18px;
  line-height: 30px;
  margin: 20px auto;
  width: 1200px;
  color: #8F8F8F
}
  .footio p{
    margin: 0px;
    padding: 0px;
  }
  .foot_line {
    line-height: 80px;
    padding-left: 20px;
  }

  .lind {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  .child {
    color: #8F8F8F;
    padding: 10px 15px;
  }

  .child:hover {
    color: #ffffff;
  }

  .shouqi {
    height: 80px;
    overflow: hidden;
  }

  .open_dia {
    height: auto;
  }

  .sho {
    padding-top: 20px;
    padding-left: 18px;
  }

  a{
    text-decoration: none;
    color: #8F8F8F!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/footer.vue